import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { Link } from 'react-router-dom';
import { Carousel, CarouselCard } from '../../../../components/Carousel';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import { useSearchContext } from '../../context';
import { useCategorySubCategories } from '../../hooks/queries/aggregations';
import { useLocation } from '../../hooks/queries/location';
import {
    generateBrowseUrl,
    getParentCategoryFromSubCategory,
} from '../../utils';

export const CategoryBrowseRelatedCategories: React.FunctionComponent = () => {
    const { data: subCategories } = useCategorySubCategories();
    const { data: location } = useLocation();

    //Get current active tag
    const { query } = useSearchContext();
    const tag = query?.tags?.[0] || '';
    const activeTag = CATEGORY_CONTENT_MAP[tag];

    //Check if current active tag is a subcat
    const isActiveSubCategory = tag.includes('EventbriteSubCategory');
    const parentTagKey = isActiveSubCategory
        ? getParentCategoryFromSubCategory(tag || '')
        : '';
    const parentTag = CATEGORY_CONTENT_MAP[parentTagKey];

    if (!location || !subCategories) return null;

    const activeTagDisplayName = isActiveSubCategory
        ? parentTag.title
        : activeTag?.title;

    const filteredSubCategories = isActiveSubCategory
        ? subCategories.filter((tag) => tag?.key !== activeTag?.key)
        : subCategories;

    if (!filteredSubCategories.length) {
        return null;
    }

    return (
        <CategoryBrowseBucket
            title={gettext(
                "Explore what's popular within %(activeTagDisplayName)s",
                {
                    activeTagDisplayName,
                },
            )}
            wrappingClasses="category-browse-bucket__centered"
        >
            <Carousel cards={filteredSubCategories}>
                {(subCategory) => {
                    return (
                        <Link
                            key={subCategory?.key}
                            to={generateBrowseUrl(
                                { ...query, tags: [subCategory?.key || ''] },
                                location,
                            )}
                            onClick={() => {
                                typeof window !== 'undefined'
                                    ? window.scrollTo(0, 0)
                                    : null;
                                trackAnalyticsEvent({
                                    category: 'category-page',
                                    action: 'SubcategoryClicked',
                                    label: CATEGORY_CONTENT_MAP[
                                        subCategory?.key || ''
                                    ].title,
                                });
                            }}
                        >
                            <CarouselCard
                                title={
                                    CATEGORY_CONTENT_MAP[subCategory?.key || '']
                                        .title
                                }
                                imageUrl={
                                    CATEGORY_CONTENT_MAP[subCategory?.key || '']
                                        .imageUrl ||
                                    CATEGORY_CONTENT_MAP[activeTag?.key || '']
                                        .imageUrl
                                }
                            />
                        </Link>
                    );
                }}
            </Carousel>
        </CategoryBrowseBucket>
    );
};
